import fetch from 'isomorphic-fetch';

import config from '../config';
import callApi, { callExternalApi } from './apiCaller';

export function getFile(filename, options = { autoResize: false, width: null, height: null, format: null }) {
    const { autoResize, height, width, format } = options;
    if(filename) {
        return `${config.url}api/file/content/${filename}`;
    }
    console.error(new Error('FileMissingFilename'), filename);
    return '';
}

export function getFileUrl(filename, userId = null, method = 'get', isPublic = false, queryParameters = {}) {
    return callApi(`file/geturl${isPublic ? '/public' : ''}${queryParameters ? `?${new URLSearchParams(queryParameters).toString()}` : ''}`, 'POST', { filename, userId, method }).then(result => {
        // console.log('getFileUrl::: result', result);
        return result.url;
    });
    // return new Promise((resolve, reject) => {
    //     getFileContent(filename, userId).then(result => {
    //         console.log(result);
    //         let fileUrl = '';
    //         if(result.blob) {
    //             return result.blob().then(blob => {
    //                 console.log(blob);
    //                 fileUrl = URL.createObjectURL(blob);
    //                 resolve(fileUrl);
    //             });
    //         } else if(result.url) {
    //             fileUrl = result.url;
    //             resolve(fileUrl);
    //         }
    //     }).catch(error => {
    //         console.error('getFileUrl', error);
    //         reject(error);
    //     });
    // });
}

export function getFileContent(filename, userId = null) {
    return getFileUrl(filename, userId).then(url => {
        if(url) {
            return fetch(url, {
                method: 'GET',
            })
            .then(response => {
                return response;
            });
        }
        return Promise.reject(new Error('NoFileError'));
    }).catch(error => {
        console.error('getFileContent', error);
    });
}

const UPLOAD_MAX_ATTEMPTS = 3;

function wait(milliseconds) {
    return new Promise(resolve => setTimeout(resolve, milliseconds));
}

// Un seul essai : URL présignée fraîche + PUT S3. On vérifie result.ok car fetch
// résout aussi sur les statuts HTTP d'erreur (403 URL expirée, 5xx S3...).
function attemptUpload(filename, data, contentType, userId) {
    return getFileUrl(filename, userId, 'put').then(url => {
        if(!url) {
            throw new Error('noUploadUrl');
        }
        return fetch(url, {
            headers: new Headers({ 'Content-Type': contentType }),
            method: 'PUT',
            body: data,
        }).then(result => {
            if(!result || !result.ok) {
                throw new Error(`S3UploadFailed:${result ? result.status : 'noResponse'}`);
            }
            return true;
        });
    });
}

export function uploadFile(filename, data, contentType = '', userId = null) {
    const run = attempt => attemptUpload(filename, data, contentType, userId).catch(err => {
        if(attempt >= UPLOAD_MAX_ATTEMPTS) {
            console.error(`UploadFile:::Echec definitif apres ${attempt} tentatives`, filename, err);
            throw err;
        }
        // Backoff exponentiel : ~1s, 2s, 4s. Couvre les coupures reseau / veille courte.
        const delay = 1000 * Math.pow(2, attempt - 1);
        console.warn(`UploadFile:::Tentative ${attempt} echouee, nouvel essai dans ${delay}ms`, filename, err);
        return wait(delay).then(() => run(attempt + 1));
    });

    return run(1);
}

export function getFiles(path) {
    return new Promise((resolve, reject) => {
    });
}

export function blobToFile(blob, fileName) {
    // A Blob() is almost a File() - it's just missing name / lastModified.
    // Modern File instances expose lastModifiedDate as a getter-only property,
    // so mutating the blob in place throws (Dropzone File, native File, etc.).
    if(typeof blob === 'string') {
        blob = new Blob([blob]);
    }
    if(typeof File !== 'undefined') {
        return new File([blob], fileName, {
            type: blob.type || '',
            lastModified: blob.lastModified || Date.now(),
        });
    }
    try {
        blob.lastModifiedDate = new Date();
        blob.name = fileName;
    } catch(err) {
        // Legacy browsers that reject mutation: return the blob as-is.
    }
    return blob;
}

export function getBlobContent(blob) {
    console.log(blob.type, blob);
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        // This fires after the blob has been read/loaded.
        reader.addEventListener('loadend', e => {
            return resolve(e.srcElement.result);
        });
        // Start reading the blob as text.
        reader.readAsText(blob);
    });
}

export function deleteFile(path) {
    return callApi('file/remove', 'delete', { filename: path });
}
